export const adTemplatesTr = {
  title: 'Reklam Şablonu Kütüphanesi',
  subtitle: 'Hazır reklam şablonları — birini seçin ve kampanyanızı dakikalar içinde başlatın.',
  stats: {
    totalTemplates: 'Toplam Şablon',
    avgConversionRate: 'Ort. Dönüşüm Oranı',
    platformsCovered: 'Kapsanan Platformlar',
    avgSetupTime: 'Ort. Kurulum Süresi'
  },
  searchPlaceholder: 'Şablon adı, platform veya etikete göre ara...',
  sort: {
    popular: 'Sırala: En Popüler',
    conversion: 'Sırala: En Yüksek Dönüşüm',
    leads: 'Sırala: En Fazla Müşteri Adayı'
  },
  showing: 'Gösteriliyor',
  templates: 'şablon',
  in: 'içinde',
  clearFilters: 'Filtreleri temizle',
  noTemplatesFound: 'Şablon bulunamadı',
  noTemplatesDesc: 'Aradığınızı bulmak için arama veya kategori filtrenizi ayarlamayı deneyin.',
  showAllTemplates: 'Tüm Şablonları Göster',
  cta: {
    title: 'İlk kampanyanızı başlatmaya hazır mısınız?',
    subtitle: 'Yukarıdaki herhangi bir şablonu seçin ve 24 saat içinde yayına girin. Tasarım becerisi gerekmez.',
    button: 'Şimdi Kampanya Oluştur'
  }
};

export default adTemplatesTr;
